var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"center",attrs:{"id":_vm.content.key}},[_c('img',{attrs:{"src":_vm.content.img,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }